"use client";

import { motion, useReducedMotion } from "framer-motion";

import { BAR } from "./motion";

// Daily-visits bar chart. Heights are the Figma bar heights as a share of the
// tallest (134px), so the silhouette is exact while the chart itself sizes to
// whatever box it is given. The final bar is the highlighted one.
const BARS = [
  { height: "50%", tone: "bg-white opacity-20" },
  { height: "69%", tone: "bg-white opacity-20" },
  { height: "44%", tone: "bg-white opacity-20" },
  { height: "87%", tone: "bg-white opacity-25" },
  { height: "63%", tone: "bg-white opacity-20" },
  { height: "100%", tone: "bg-blue-500 opacity-80" },
];

// The bars grow out of the baseline left to right, so the eye arrives on the
// tall blue one last. Height rather than scaleY: the bars are rounded, and
// scaling would squash the corner radius along with them.
export default function VisitsChart({ className = "", delay = 0 }) {
  const reduce = useReducedMotion();

  return (
    <div aria-hidden="true" className={`flex items-end gap-[5.5%] ${className}`}>
      {BARS.map((bar, i) => (
        <motion.span
          key={i}
          className={`flex-1 rounded-lg ${bar.tone}`}
          initial={{ height: "0%" }}
          whileInView={{ height: bar.height }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{
            duration: reduce ? 0 : BAR.duration,
            delay: reduce ? 0 : delay + i * BAR.stagger,
            ease: BAR.ease,
          }}
        />
      ))}
    </div>
  );
}
